module.exports = __webpack_public_path__ + "static/media/glyph-understand.3bbfc50b.svg";